var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('v-alert',{attrs:{"dense":"","text":"","type":_vm.mode}},[_vm._v(_vm._s(_vm.text))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }